import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/admin.css';

const BASE = 'https://menu.searchisend.in';

const AdminMonetization = () => {
    const navigate = useNavigate();
    const token = localStorage.getItem('saas_token');
    const user = JSON.parse(localStorage.getItem('saas_user') || '{}');
    
    const [isOptedIn, setIsOptedIn] = useState(false);
    const [earnings, setEarnings] = useState(0);
    const [proposals, setProposals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [previewImage, setPreviewImage] = useState(null);

    useEffect(() => {
        if (!token) {
            navigate('/login');
            return;
        }
        if (user.plan_level === 'Free') {
            setLoading(false);
            return;
        }

        fetchMonetizationData();
        // eslint-disable-next-line
    }, []);

    const fetchMonetizationData = async () => {
        setLoading(true);
        try {
            // Get Status
            let fd = new FormData();
            fd.append('action', 'get_monetization_status');
            let res = await fetch(`${BASE}/apimenu/v2/v2_restaurant_monetization.php`, {
                method: 'POST', headers: { 'Authorization': `Bearer ${token}` }, body: fd
            });
            let data = await res.json();
            if (data.success) {
                setIsOptedIn(data.is_opted_in);
                setEarnings(data.earnings);
            }

            // Get Proposals
            fd = new FormData();
            fd.append('action', 'get_proposals');
            res = await fetch(`${BASE}/apimenu/v2/v2_restaurant_monetization.php`, {
                method: 'POST', headers: { 'Authorization': `Bearer ${token}` }, body: fd
            });
            data = await res.json();
            if (data.success) {
                setProposals(data.proposals);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleToggleOptIn = async (e) => {
        const checked = e.target.checked;
        setIsOptedIn(checked); // Optimistic UI
        try {
            const fd = new FormData();
            fd.append('action', 'toggle_opt_in');
            fd.append('opt_in', checked ? 'true' : 'false');
            await fetch(`${BASE}/apimenu/v2/v2_restaurant_monetization.php`, {
                method: 'POST', headers: { 'Authorization': `Bearer ${token}` }, body: fd
            });
        } catch (err) {}
    };

    const handleSetStatus = async (adId, status) => {
        try {
            const fd = new FormData();
            fd.append('action', 'set_proposal_status');
            fd.append('ad_id', adId);
            fd.append('status', status);
            const res = await fetch(`${BASE}/apimenu/v2/v2_restaurant_monetization.php`, {
                method: 'POST', headers: { 'Authorization': `Bearer ${token}` }, body: fd
            });
            const data = await res.json();
            if (data.success) {
                setProposals(prev => prev.map(p => p.id === adId ? { ...p, my_status: status } : p));
            }
        } catch (err) {}
    };

    if (user.plan_level === 'Free') {
        return (
            <div>
                <Link to="/manage_v2_secure_auth/" className="sticky-back-btn">
    <i className="fas fa-arrow-left"></i> Back to Dashboard
</Link>
                <div className="admin-content">
                    <div className="admin-card" style={{ textAlign: 'center', padding: '50px 20px' }}>
                        <i className="fas fa-crown" style={{ fontSize: '3rem', color: '#f59e0b', marginBottom: '20px' }}></i>
                        <h2>Unlock Ad Monetization</h2>
                        <p style={{ color: '#6b7280', maxWidth: '500px', margin: '0 auto 30px' }}>
                            Turn your digital menu traffic into passive income! Upgrade to the Pro plan to start accepting local ad proposals and earning a share of the revenue.
                        </p>
                        <Link to="/manage_v2_secure_auth/subscription" className="btn-primary" style={{ padding: '12px 30px', fontSize: '1.1rem', textDecoration: 'none' }}>
                            View Subscription Plans
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div>
            <Link to="/manage_v2_secure_auth/" style={{ position: 'sticky', top: 0, zIndex: 100, backgroundColor: 'var(--card-bg-color, #fff)', padding: '15px 0', margin: '-24px -24px 20px -24px', paddingLeft: '24px', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600', color: 'var(--primary-orange)', textDecoration: 'none', borderBottom: '1px solid var(--border-color)', width: 'calc(100% + 48px)' }}>
    <i className="fas fa-arrow-left"></i> Back to Dashboard
</Link>
            <div className="admin-content">
                <div className="admin-card" style={{ marginBottom: '20px', background: 'linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '20px' }}>
                            <div>
                                <h2 style={{ margin: '0 0 10px 0', color: '#111827' }}>Monetize Your Menu</h2>
                                <p style={{ color: '#4b5563', margin: 0 }}>Turn your digital menu traffic into passive income by displaying targeted, high-quality local ads.</p>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#10b981' }}>₹{earnings}</div>
                                <div style={{ fontSize: '12px', color: '#6b7280' }}>Total Earned Credits</div>
                            </div>
                        </div>

                        <div style={{ marginTop: '20px', padding: '15px', background: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', gap: '15px' }}>
                            <div 
                                onClick={() => handleToggleOptIn({ target: { checked: !isOptedIn } })}
                                style={{ position: 'relative', width: '50px', height: '26px', display: 'inline-block' }}
                            >
                                <span style={{
                                    position: 'absolute', cursor: 'pointer',
                                    top: 0, left: 0, right: 0, bottom: 0,
                                    backgroundColor: isOptedIn ? 'var(--primary-orange)' : '#ccc',
                                    transition: '.4s', borderRadius: '34px'
                                }}>
                                    <span style={{
                                        position: 'absolute',
                                        height: '18px', width: '18px',
                                        left: isOptedIn ? '28px' : '4px',
                                        bottom: '4px',
                                        backgroundColor: 'white',
                                        transition: '.4s', borderRadius: '50%'
                                    }}></span>
                                </span>
                            </div>
                            <div>
                                <strong>Enable Ad Network</strong>
                                <p style={{ margin: 0, fontSize: '0.85rem', color: '#6b7280' }}>Allow local sponsors to send ad proposals to you.</p>
                            </div>
                        </div>
                    </div>

                    {isOptedIn && (
                        <div className="admin-card">
                            <h3>Ad Proposals</h3>
                            <p style={{ fontSize: '0.9rem', color: '#6b7280', marginBottom: '15px' }}>You have full control. Review and approve the ads you want to display to your customers.</p>
                            
                            {loading ? <p>Loading proposals...</p> : (
                                <div className="monetization-table-wrap">
                                    <table className="admin-table monetization-table">
                                        <thead>
                                            <tr>
                                                <th className="hide-on-mobile">Banner</th>
                                                <th>Sponsor</th>
                                                <th className="hide-on-mobile">Ad Rates</th>
                                                <th className="hide-on-mobile">Status</th>
                                                <th className="hide-on-mobile">Performance</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {proposals.map(p => (
                                                <tr key={p.id}>
                                                    <td className="banner-td">
                                                        <img 
                                                            src={p.image_url} 
                                                            alt="ad" 
                                                            onClick={() => setPreviewImage(p.image_url)}
                                                            style={{ width: '80px', height: '60px', borderRadius: '8px', objectFit: 'cover', cursor: 'pointer', border: '1px solid #e5e7eb' }} 
                                                        />
                                                    </td>
                                                    <td className="flex-grow-mobile">
                                                        <strong>{p.company_name}</strong><br/>
                                                        <span style={{fontSize: '0.9rem'}}>{p.title}</span>
                                                        <div style={{fontSize: '0.8rem', color: '#6366f1', marginTop: '3px', textTransform: 'capitalize'}}>
                                                            <i className="fas fa-layer-group"></i> Placement: {p.placement_zone ? p.placement_zone.replace('_', ' ') : 'N/A'}
                                                        </div>
                                                        <div className="mobile-only-td" style={{marginTop: '5px'}}>
                                                            <span className={`status-badge ${p.my_status.toLowerCase()}`}>{p.my_status}</span>
                                                            <span style={{marginLeft: '8px', fontSize: '0.8rem', color: '#6b7280'}}>₹{(p.my_cpc_rate || 0).toFixed(2)}/click | ₹{(p.my_cpm_rate || 0).toFixed(2)}/1k views</span>
                                                        </div>
                                                        <div className="mobile-only-td" style={{marginTop: '5px', fontSize: '0.85rem'}}>
                                                            <span><i className="fas fa-mouse-pointer text-gray-400"></i> {p.my_clicks || 0}</span>
                                                            <span style={{marginLeft: '8px'}}><i className="fas fa-eye text-gray-400"></i> {p.my_impressions || 0}</span>
                                                            <span style={{marginLeft: '10px', color: '#10b981', fontWeight: '600'}}>Earned: ₹{p.my_earnings ? parseFloat(p.my_earnings).toFixed(2) : '0.00'}</span>
                                                        </div>
                                                    </td>
                                                    <td className="hide-on-mobile">
                                                        <div style={{fontSize: '0.9rem'}}>₹{(p.my_cpc_rate || 0).toFixed(2)} / click</div>
                                                        <div style={{fontSize: '0.9rem', color: '#6b7280'}}>₹{(p.my_cpm_rate || 0).toFixed(2)} / 1k views</div>
                                                    </td>
                                                    <td className="hide-on-mobile">
                                                        <span className={`status-badge ${p.my_status.toLowerCase()}`}>{p.my_status}</span>
                                                    </td>
                                                    <td className="hide-on-mobile">
                                                        <div style={{fontSize: '0.9rem'}}><i className="fas fa-mouse-pointer text-gray-400"></i> {p.my_clicks || 0} Clicks</div>
                                                        <div style={{fontSize: '0.9rem'}}><i className="fas fa-eye text-gray-400"></i> {p.my_impressions || 0} Views</div>
                                                        <div style={{fontSize: '0.9rem', color: '#10b981', fontWeight: '600'}}>Earned: ₹{p.my_earnings ? parseFloat(p.my_earnings).toFixed(2) : '0.00'}</div>
                                                    </td>
                                                    <td className="action-btns-td">
                                                        {p.my_status !== 'Approved' && (
                                                            <button onClick={() => handleSetStatus(p.id, 'Approved')} className="btn-success">Approve</button>
                                                        )}
                                                        {p.my_status !== 'Blocked' && (
                                                            <button onClick={() => handleSetStatus(p.id, 'Blocked')} className="btn-danger">Block</button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                            {proposals.length === 0 && <tr><td colSpan="5" style={{ textAlign: 'center', padding: '30px' }}>No active proposals for your location right now.</td></tr>}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    )}
                </div>

            {/* Full Screen Image Preview Modal */}
            {previewImage && (
                <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                    <div style={{ position: 'relative', maxWidth: '100%', maxHeight: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <button 
                            onClick={() => setPreviewImage(null)}
                            style={{ position: 'absolute', top: '-40px', right: '0', background: 'none', border: 'none', color: '#fff', fontSize: '2rem', cursor: 'pointer' }}
                        >
                            &times;
                        </button>
                        <img src={previewImage} alt="Ad Preview" style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0,0,0,0.5)' }} />
                    </div>
                </div>
            )}

            <style>{`
                .monetization-table-wrap { overflow-x: auto; }
                .btn-success { background-color: #10b981; color: white; border: none; padding: 6px 16px; border-radius: 6px; cursor: pointer; font-size: 0.9rem; font-weight: 500; transition: background 0.2s; margin-right: 8px; }
                .btn-success:hover { background-color: #059669; }
                .btn-danger { background-color: #ef4444; color: white; border: none; padding: 6px 16px; border-radius: 6px; cursor: pointer; font-size: 0.9rem; font-weight: 500; transition: background 0.2s; }
                .btn-danger:hover { background-color: #dc2626; }
                
                @media (max-width: 768px) {
                    .monetization-table-wrap { overflow-x: visible !important; width: 100%; display: block; border: none; }
                    .monetization-table { min-width: 100% !important; border-collapse: separate; border-spacing: 0 10px; }
                    .monetization-table thead { display: none; }
                    .monetization-table tbody tr { background: #fff; box-shadow: 0 2px 8px rgba(0,0,0,0.06); border-radius: 12px; display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; margin-bottom: 10px; border: 1px solid #f1f5f9; flex-wrap: wrap; }
                    .monetization-table td { display: block; padding: 0 !important; border: none !important; white-space: normal !important; }
                    .monetization-table td.banner-td { margin-right: 15px; flex-shrink: 0; }
                    .monetization-table td.flex-grow-mobile { flex: 1; min-width: 0; }
                    .monetization-table td.action-btns-td { width: 100%; display: flex; justify-content: flex-start; gap: 10px; margin-top: 12px; padding-top: 12px !important; border-top: 1px dashed #e2e8f0 !important; }
                    
                    .hide-on-mobile { display: none !important; }
                    .mobile-only-td { display: block !important; }
                    .btn-success { margin-right: 0; flex: 1; }
                    .btn-danger { flex: 1; }
                }
                @media (min-width: 769px) {
                    .mobile-only-td { display: none !important; }
                    .monetization-table th, .monetization-table td { white-space: nowrap; vertical-align: middle; }
                }
            `}</style>
        </div>
    );
};

export default AdminMonetization;
